export type Themes = 'todoist' | 'twist' | 'doist'

export const todoist = 'todoist'
export const twist = 'twist'
export const doist = 'doist'
export const themes = { todoist, twist, doist } as const
